import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { MDTApp } from '../../../../../actions/bootAction.js';
import {
    NotificationIcon
} from '../../../../atoms/mdt-iconset/index.js';
import { getNotificationCount } from '../../../../../actions/NotificationListStore.js';
import { sendEventTrackingData } from '../../../../../helpers/commonUtils.js';

import './serverNotification.css';

const ServerNotification = ({
    notificationCount,
    customer,
    getNotificationCount,
    pageName,
}) => {

    useEffect(() => {
        if (customer) {
            getNotificationCount();
        }
    }, [customer]);

    const trackNotificationClick = () => {
        const eventParamObj = {
            eventCategory: 'globalHeader',
            eventAction: 'notification',
            eventLabel: pageName,
            processLabels: false,
        };
        sendEventTrackingData(eventParamObj);
    };
    const redirectToNotifications = () => {
        trackNotificationClick();
        MDTApp.goto(MDTApp.getSetting('links.notifications'));
    };

    return <NotificationIcon
        iconWhenNotification={ 'filledBell' }
        iconEmpty={ 'unfilledBell' }
        className={ 'badge' }
        iconCount={ notificationCount.unreadCount }
        onIconClicked={ redirectToNotifications }
    />
};

const mapStateToProps = (state) => {
    return {
        notificationCount: state.notification.count,
        customer: state.meDetails.customerId,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getNotificationCount: () => dispatch(getNotificationCount()),
        redirectTo: (pagename, data, queryObj) => dispatch({ type: pagename, payload: data, query: queryObj }),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ServerNotification);
